export default "__VITE_ASSET__DEsUiEMk__"